// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.noFirMessage {
  padding-left: 32%;
}

.selected-avoid {
  background: #b5b0b0 !important;
  margin-top: 5px !important;
  margin-left: 5px !important;
  margin-bottom: 5px !important;
  height: 37px !important;
  display: inline-block !important;
  border-radius: 20px !important;
  padding-left: 10px !important;
}

.select-item {
  background: #e6e6e6 !important;
  margin-top: 5px !important;
  margin-left: 5px !important;
  margin-bottom: 5px !important;
  height: 37px !important;
  display: inline-block !important;
  border-radius: 20px !important;
  padding-left: 10px !important;
}

.selected-firName-avoid {
  background: #b5b0b0 !important;
  margin-top: 5px !important;
  margin-left: 5px !important;
  margin-bottom: 5px !important;
  height: auto !important;
  min-height: 37px !important;
  display: inline-flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  padding: 6px 10px;
}

.select-item-avoid {
  background: #e6e6e6 !important;
  margin-top: 5px !important;
  margin-left: 5px !important;
  margin-bottom: 5px !important;
  height: auto !important;
  min-height: 37px !important;
  display: inline-flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  padding: 6px 10px !important;
  color: var(--ion-color-headertext) !important;
}

.firNames {
  font-size: smaller;
  color: var(--ion-color-medium) !important;
  line-height: 1.2;
  margin-top: 2px;
}`, "",{"version":3,"sources":["webpack://./src/app/flight-planning/route-plan/avoid-country/avoid-country.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;;AAEA;EACE,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,uBAAA;EACA,gCAAA;EACA,8BAAA;EACA,6BAAA;AACF;;AAEA;EACE,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,uBAAA;EACA,gCAAA;EACA,8BAAA;EACA,6BAAA;AACF;;AACA;EACE,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,uBAAA;EACA,2BAAA;EACA,+BAAA;EACE,iCAAA;EACF,kCAAA;EACA,iBAAA;AAEF;;AAAA;EACE,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,uBAAA;EACA,2BAAA;EACA,+BAAA;EACA,iCAAA;EACA,kCAAA;EACA,4BAAA;EACA,6CAAA;AAGF;;AADA;EACE,kBAAA;EACA,yCAAA;EACC,gBAAA;EACD,eAAA;AAIF","sourcesContent":[".noFirMessage {\n  padding-left: 32%;\n}\n\n.selected-avoid {\n  background: #b5b0b0 !important;\n  margin-top: 5px !important;\n  margin-left: 5px !important;\n  margin-bottom: 5px !important;\n  height: 37px !important;\n  display: inline-block !important;\n  border-radius: 20px !important;\n  padding-left: 10px !important;\n}\n\n.select-item {\n  background: #e6e6e6 !important;\n  margin-top: 5px !important;\n  margin-left: 5px !important;\n  margin-bottom: 5px !important;\n  height: 37px !important;\n  display: inline-block !important;\n  border-radius: 20px !important;\n  padding-left: 10px !important;\n}\n.selected-firName-avoid {\n  background: #b5b0b0 !important;\n  margin-top: 5px !important;\n  margin-left: 5px !important;\n  margin-bottom: 5px !important;\n  height: auto !important;\n  min-height: 37px !important;\n  display: inline-flex !important;\n    flex-direction: column !important;\n  justify-content: center !important;\n  padding: 6px 10px;\n}\n.select-item-avoid {\n  background: #e6e6e6 !important;\n  margin-top: 5px !important;\n  margin-left: 5px !important;\n  margin-bottom: 5px !important;\n  height: auto !important;\n  min-height: 37px !important;\n  display: inline-flex !important;\n  flex-direction: column !important;\n  justify-content: center !important;\n  padding: 6px 10px !important;\n  color: var(--ion-color-headertext) !important;\n}\n.firNames {\n  font-size:smaller;\n  color: var(--ion-color-medium) !important;\n   line-height: 1.2;\n  margin-top: 2px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
